export const widgetName: string = 'collection-slider';
export const widgetDisplayName: string = 'Collection Slider';
export const widgetCategory: string = 'Reply.com';
export const widgetSelector: string = 'collection-slider';
export const widgetEditorSelector: string = 'collection-slider-editor';
export const widgetRuntimeSelector: string = 'collection-slider-runtime';
export const defaultContentTypesId: string[] = ['article', 'news', 'event', 'website'];

export const defaultItemsOffset: number = 0;
export const defaultItemsLimit: number = 10;
export const defaultOrderingField: string = 'sortDate';
export const defaultFilteringDateField: string = 'sortDate';
export const defaultOrderingType: string = 'desc';
export const implictReferenceCMSContentType: string = 'article';